// Frosted Elite lock — blurred preview content behind a gold CTA.

import React from 'react';
import { GS } from '../../lib/designTokens';
import { Card } from './ui';

export const EliteLockCard = ({ title, onUpgrade, children }: {
  title: string;
  onUpgrade?: () => void;
  children?: React.ReactNode;
}) => (
  <Card className="relative">
    <div className="p-4 select-none pointer-events-none" style={{ filter: 'blur(7px)', opacity: 0.5 }} aria-hidden="true">
      {children}
    </div>
    <div
      className="absolute inset-0 flex flex-col items-center justify-center gap-2.5 px-6"
      style={{ background: 'rgba(255,255,255,0.45)', backdropFilter: 'blur(2px)' }}
    >
      <div className="w-9 h-9 rounded-xl flex items-center justify-center text-base" style={{ background: GS.goldSoft, border: `1px solid ${GS.gold}` }}>
        🔒
      </div>
      <p className="text-xs font-black text-center" style={{ color: GS.ink }}>{title}</p>
      <button
        onClick={onUpgrade}
        className="px-5 py-2 rounded-xl text-[11px] font-black text-ink"
        style={{ background: `linear-gradient(150deg, ${GS.gold}, ${GS.gold2})`, letterSpacing: '0.04em' }}
      >
        Unlock with Elite
      </button>
    </div>
  </Card>
);

/** Static placeholder rows rendered blurred behind the lock. */
export const LockPreview = () => (
  <div className="space-y-3">
    <div className="flex gap-3">
      <div className="w-16 h-16 rounded-full" style={{ background: GS.panel2 }} />
      <div className="flex-1 space-y-2 pt-2">
        <div className="h-3 rounded w-3/4" style={{ background: GS.panel2 }} />
        <div className="h-3 rounded w-1/2" style={{ background: GS.panel2 }} />
      </div>
    </div>
    <svg width="100%" height="56" viewBox="0 0 330 56" preserveAspectRatio="none" aria-hidden="true">
      <polyline points="0,44 37,36 74,40 111,24 148,32 185,18 222,24 259,12 296,18 330,8" fill="none" stroke="#0EA372" strokeWidth="2.5" />
    </svg>
  </div>
);
